import type { TFunction } from 'i18next';

export const CASHBACK_STATUS = {
  PENDING: 'PENDING',
  PENDING_EXCLUSIVE: 'PENDING_EXCLUSIVE',
  PROCESSING: 'PROCESSING',
  ERROR_PROCESSING: 'ERROR_PROCESSING',
  CREATED: 'CREATED',
  ERROR_CREATING: 'ERROR_CREATING',
  CONFIRMED: 'CONFIRMED',
  EXPIRED: 'EXPIRED',
  NOT_APPLY: 'NOT_APPLY',
  REFUNDED: 'REFUNDED',
} as const;

export const getCashbackStatus = (t: TFunction) => ({
  [CASHBACK_STATUS.PENDING]: t('Pending'),
  [CASHBACK_STATUS.PENDING_EXCLUSIVE]: t('Next charge'),
  [CASHBACK_STATUS.PROCESSING]: t('Processing'),
  [CASHBACK_STATUS.ERROR_PROCESSING]: t('Failed'),
  [CASHBACK_STATUS.CREATED]: t('Created'),
  [CASHBACK_STATUS.ERROR_CREATING]: t('Failed'),
  [CASHBACK_STATUS.CONFIRMED]: t('Redeemed'),
  [CASHBACK_STATUS.EXPIRED]: t('Expired'),
  [CASHBACK_STATUS.NOT_APPLY]: t('Not apply'),
  [CASHBACK_STATUS.REFUNDED]: t('Refunded'),
});
